import "../../assets/css/carousel.scss";
import "../../assets/css/grid.scss";
import "../../assets/css/style.scss";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import PlansListStatic from "../common/PlansListStatic";

// Public "/Plans" page. The plan cards themselves are rendered by the
// shared, dark-themed PlansListStatic component (see
// components/common/PlansListStatic), which fetches active plans
// from the API directly - same call the Home page pricing section
// uses (GET /v1/plans/active).
function PlansPage() {
  return (
    <div className="App">
      <Header />
      <PlansListStatic />
      <Footer />
    </div>
  );
}

export default PlansPage;
